<template>
	<div class="product_listing">
		<div class='container'>
			<div class='inner'>

				<div
					class='product'
					v-for="(product, index) in parsedProducts"
					:key="index"
				>

					<div class='text-image'>
						<div class='text_wrapper'>
							<h2 v-html="product.title"></h2>

							<div
								class="text"
								v-html="product.excerpt"
							></div>
						</div>
						<div class='image'><img
								:src="product.image.url"
								:alt="product.image.alt"
							/></div>
					</div>

					<div class="ctas">
						<a
							class='brochure'
							v-if="product.brochure"
							:href="product.brochure.url"
							:title="'Download Brochure'"
							v-html="'Download Brochure'"
							:target="product.brochure.target ? product.brochure.target : '_blank'"
						></a>

						<a
							v-if="product.get_quote"
							:href="product.get_quote.url"
							:title="product.get_quote.title"
							v-html="product.get_quote.title"
							target="_blank"
							class='secondary quote'
						></a>

						<a
							v-if="product.view_projects"
							:href="product.view_projects.url"
							:title="product.view_projects.title"
							v-html="product.view_projects.title"
							target="_self"
							class='secondary projects'
						></a>
					</div>

					<div
						class="specifications"
						v-if="product.key_specifications"
					>

						<accordion-wrapper>

							<accordion-item>

								<template slot="accordion-trigger">
									<h3 v-html="'Key Specifications'"></h3>

								</template>

								<template slot="accordion-content">
									<p
										v-for="(spec, index) in product.key_specifications"
										:key="index"
										v-html="spec.specification"
									></p>
								</template>

							</accordion-item>

						</accordion-wrapper>

					</div>

				</div>

			</div>
		</div>
	</div>
</template>

<script>
import AccordionItem from './AccordionItem.vue';
import AccordionWrapper from './AccordionWrapper.vue';

export default {
	props: {
		products: {},
	},

	computed: {
		parsedProducts() {
			if (this.products) {
				return JSON.parse(this.products);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {},

	components: {
		AccordionItem,
		AccordionWrapper,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.product_listing {
	.inner {
		grid-column: 1 / span 12;
		display: flex;
		flex-direction: column;
		row-gap: 40px;

		.product {
			width: 100%;
			display: flex;
			flex-direction: column;

			h2 {
				width: 100%;
				margin-bottom: 10px;
			}

			.text-image {
				width: 100%;
				display: grid;
				grid-template-columns: calc(50% + 4px) 1fr;
				gap: 40px;

				@media (max-width: $mobile-xl) {
					grid-template-columns: repeat(4, 1fr);
				}

				.text_wrapper {
					@media (max-width: $mobile-xl) {
						grid-column: span 4;
					}
				}

				.text {
					font-size: 20px;
					line-height: 40px;
					font-weight: 200;
				}

				.image {
					aspect-ratio: 3 / 2;
					display: flex;

					@media (max-width: $mobile-xl) {
						grid-column: span 4;
					}

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
				}
			}

			.ctas {
				display: grid;
				grid-template-columns: 50% auto auto;
				gap: 40px;
				margin-top: 50px;

				@media (max-width: $mobile-xl) {
					grid-template-columns: repeat(4, 1fr);
					grid-template-rows: 1fr 1fr;
					gap: 20px;
				}

				a {
					background: transparent;
					padding: 10px 40px;
					text-transform: uppercase;
					text-decoration: none;
					transition: 0.2s ease all;
					font-size: 20px;
					line-height: 30px;
					color: var(--orange);
					text-align: center;
					width: calc(100% - 80px);
					display: flex;
					justify-content: center;
					border: 4px solid var(--orange);
					text-transform: capitalize;

					&.brochure {
						@media (max-width: $mobile-xl) {
							grid-column: span 4;
						}
					}

					&.secondary {
						background: transparent;
						border: 4px solid var(--navy);
						color: var(--navy);

						@media (max-width: $mobile-xl) {
							grid-column: span 2;
						}

						&:hover {
							background: var(--navy);
							color: var(--white);
							transition: 0.2s ease all;
							border: 4px solid var(--navy);
						}
					}

					&:hover {
						background: var(--orange);
						color: var(--white);
						transition: 0.2s ease all;
						border: 4px solid var(--orange);
					}
				}
			}

			.specifications {
				margin-top: 40px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/ProductListing.vue